/* TownStyle — interacciones (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.ts-reveal:not(.ts-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ts-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ts-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCountUp() {
    var nums = document.querySelectorAll('[data-ts-count]');
    if (!nums.length) return;
    function run(el) {
      var target = parseFloat(el.getAttribute('data-ts-count')) || 0;
      var suffix = el.getAttribute('data-ts-suffix') || '';
      if (reduce) { el.textContent = target + suffix; return; }
      var start = null, dur = 1600;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { nums.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    nums.forEach(function (el) { io.observe(el); });
  }

  function initHeroParallax() {
    if (reduce) return;
    document.querySelectorAll('[data-ts-parallax]').forEach(function (hero) {
      var img = hero.querySelector('.ts-hero__img');
      var strength = parseFloat(hero.getAttribute('data-ts-parallax')) || 0;
      if (!img || !strength) return;
      hero.addEventListener('mousemove', function (ev) {
        var r = hero.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5;
        var y = (ev.clientY - r.top) / r.height - 0.5;
        img.style.transform = 'translate(' + (x * strength) + 'px,' + (y * strength) + 'px) rotate(' + (x * 3) + 'deg)';
      });
      hero.addEventListener('mouseleave', function () { img.style.transform = ''; });
    });
  }

  function initProduct() {
    document.querySelectorAll('[data-ts-product]').forEach(function (root) {
      var dataEl = root.querySelector('[data-ts-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var form = root.querySelector('form[action*="/cart/add"]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var addBtn = root.querySelector('[data-ts-add]');
      var addLabel = addBtn ? addBtn.getAttribute('data-label-add') : '';
      var soldLabel = addBtn ? addBtn.getAttribute('data-label-sold') : '';
      var priceNow = root.querySelector('[data-ts-price]');
      var priceOld = root.querySelector('[data-ts-compare]');
      var saveBadge = root.querySelector('[data-ts-save]');
      var mainImg = root.querySelector('[data-ts-main-img]');
      var thumbs = root.querySelectorAll('[data-ts-thumb]');
      var stickyInfo = document.querySelector('[data-ts-sticky-info]');
      var stickyBtn = document.querySelector('[data-ts-sticky-btn]');
      var selectedLabels = root.querySelectorAll('[data-ts-selected]');
      var money = root.getAttribute('data-money') || '${{amount}}';

      function fmt(cents) {
        var v = (cents / 100).toFixed(2);
        var parts = v.split('.');
        var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
        return money.replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0] + ',' + parts[1])
          .replace(/\{\{\s*amount\s*\}\}/, withCommas);
      }

      function showImage(src, id) {
        if (!mainImg || !src) return;
        mainImg.style.opacity = 0;
        setTimeout(function () { mainImg.src = src; mainImg.removeAttribute('srcset'); mainImg.style.opacity = 1; }, 150);
        thumbs.forEach(function (t) { t.classList.toggle('is-active', String(t.getAttribute('data-media-id')) === String(id)); });
      }

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { showImage(t.getAttribute('data-src'), t.getAttribute('data-media-id')); });
      });

      function currentOptions() {
        var opts = [];
        root.querySelectorAll('[data-ts-option]').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          opts.push(c ? c.value : null);
        });
        return opts;
      }

      function update() {
        var opts = currentOptions();
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
        selectedLabels.forEach(function (el, i) { if (opts[i] != null) el.textContent = opts[i]; });
        if (!v) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = soldLabel; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceNow) priceNow.textContent = fmt(v.price);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (priceOld) { priceOld.textContent = onSale ? fmt(v.compare_at_price) : ''; priceOld.hidden = !onSale; }
        if (saveBadge) {
          saveBadge.hidden = !onSale;
          if (onSale) saveBadge.textContent = saveBadge.getAttribute('data-template').replace('[pct]', Math.round((1 - v.price / v.compare_at_price) * 100) + '%');
        }
        if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? addLabel : soldLabel; }
        if (stickyBtn) { stickyBtn.disabled = !v.available; }
        if (stickyInfo) stickyInfo.textContent = v.title + ' · ' + fmt(v.price);
        if (v.featured_media) showImage(v.featured_media.src, v.featured_media.id);
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      root.querySelectorAll('[data-ts-option] input').forEach(function (inp) { inp.addEventListener('change', update); });

      var qty = root.querySelector('[data-ts-qty]');
      if (qty) {
        var input = qty.querySelector('input');
        qty.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = parseInt(input.value, 10) || 1;
            n += parseInt(b.getAttribute('data-step'), 10);
            input.value = Math.max(1, n);
          });
        });
      }

      var sticky = document.querySelector('[data-ts-sticky]');
      if (sticky && addBtn && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var below = e.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', !e.isIntersecting && below);
          });
        });
        io.observe(addBtn);
      }
    });
  }

  function init() {
    initReveal();
    initCountUp();
    initHeroParallax();
    initProduct();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function () { initReveal(); initCountUp(); initHeroParallax(); initProduct(); });
})();
